import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=a098ad22&scoped=true&lang=pug&"
import script from "./ProjectNotes.vue?vue&type=script&lang=ts&"
export * from "./ProjectNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a098ad22",
  null
  
)

export default component.exports